import axios from 'axios';
import resolvePath from 'utils/resolvePath';
// Action
const SELECT = 'accusations/select';
const GET_ACCUSATIONS_REASONS_REQUEST = 'accusations/getAccusationsReasonsRequest';
const GET_ACCUSATIONS_REASONS_SUCCESS = 'accusations/getAccusationsReasonsSuccess';
const GET_ACCUSATIONS_REASONS_FAILURE = 'accusations/getAccusationsReasonsFailure';
const POST_ACCUSATIONS_REQUEST = 'accusations/postAccusationsRequest';
const POST_ACCUSATIONS_SUCCESS = 'accusations/postAccusationsSuccess';
const POST_ACCUSATIONS_FAILURE = 'accusations/postAccusationsFailure';
// Action Creator
export const select = (selectedReasonId) => {
    return {
        payload: {
            selectedReasonId,
        },
        type: SELECT,
    };
};
export const getAccusationsReasonsRequest = () => {
    return {
        type: GET_ACCUSATIONS_REASONS_REQUEST,
    };
};
export const getAccusationsReasonsSuccess = (reasons) => {
    return {
        payload: {
            reasons,
        },
        type: GET_ACCUSATIONS_REASONS_SUCCESS,
    };
};
export const getAccusationsReasonsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_ACCUSATIONS_REASONS_FAILURE,
    };
};
export const getAccusationsReasons = (authToken) => (dispatch) => {
    dispatch(getAccusationsReasonsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(resolvePath.api('accusations/reasons'), config)
        .then((response) => dispatch(getAccusationsReasonsSuccess(response.data)))
        .catch((error) => {
        dispatch(getAccusationsReasonsFailure(error));
        throw error;
    });
};
export const postAccusationsRequest = () => {
    return {
        type: POST_ACCUSATIONS_REQUEST,
    };
};
export const postAccusationsSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: POST_ACCUSATIONS_SUCCESS,
    };
};
export const postAccusationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_ACCUSATIONS_FAILURE,
    };
};
export const postAccusations = (authToken, parameters) => (dispatch) => {
    dispatch(postAccusationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .post(resolvePath.api('accusations'), parameters, config)
        .then((response) => dispatch(postAccusationsSuccess(response.data)))
        .catch((error) => {
        dispatch(postAccusationsFailure(error));
        throw error;
    });
};
const initialState = {
    error: null,
    isFetching: false,
    reasons: [],
    response: null,
    selectedReasonId: null,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case SELECT: {
            return Object.assign(Object.assign({}, state), { selectedReasonId: action.payload.selectedReasonId });
        }
        case GET_ACCUSATIONS_REASONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_ACCUSATIONS_REASONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, reasons: action.payload.reasons });
        }
        case GET_ACCUSATIONS_REASONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_ACCUSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_ACCUSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, response: Object.assign({}, action.payload.response) });
        }
        case POST_ACCUSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
